<app-loader *ngIf="loaderIcon | async"></app-loader>
<div class="content-area">
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="fw-semibold">Email Templates</h5>
    </div>
    <hr />
    <form [formGroup]="EmailTemplateForm" novalidate>
        <div class="row">
            <div class="col-12 text-start mt-2">
                <div class="row g-3">
                    <div class="col-md-6 col-lg-3">
                        <label for="type" class="form-label">Type <span class="required">*</span></label>
                    <select class="form-control d-inline" id="ddlType"  formControlName="type">
                            <option value="0" hidden i18n>Select </option>
                            <option value="1" i18n>Text</option>
                        </select>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <label for="baseTemplate" class="form-label">Base Template  <span class="required">*</span></label>
                        <ejs-dropdownlist id='ddlTemplate' [dataSource]='baseTemplateTypes' formControlName="baseTemplateType" 
                        [fields]='BaseTemplateDropdownFields' placeholder='Select base template' (change)="GetselectedBaseTemplate(null)"></ejs-dropdownlist>
                    </div>
                    <div class="col-md-6 col-lg-3" [formGroup]="MergeFieldForm">
                        <label for="selectItem" class="form-label">Select</label>
                        <select class="form-control d-inline" id="ddlSelect"  formControlName="selectedField"  (change)="MergeFieldSelected()">
                            <option value="" hidden i18n>Select Merge field</option>
                            <option *ngFor="let item of MergeFields; let i=index" value="{{item.MergeValue}}" i18n>{{item.MergeText}}</option>
                        </select>
                    </div>
                    <div class="col-md-6 col-lg-3">
                        <label for="templateName" class="form-label">Template name  <span class="required">*</span></label>
                        <input type="text" class="form-control d-inline" id="txtTemplateName" formControlName="templateName" required>  
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-start mt-2">
                
                <div class="NgxEditor__Wrapper" >

                    <ngx-editor-menu
                        [editor]="editor"
                        [toolbar]="toolbar"
                        ></ngx-editor-menu>
                    <ngx-editor
                        [editor]="editor"
                        [disabled]="false"
                        formControlName="templateContent"
                        [placeholder]="'Type here...'"
                    ></ngx-editor>

                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-12 text-end mt-2 mb-3">
 
                @if(isEditMode) {
                    <button class="btn btnAS me-1" [userPermissionHandler]="editPermissionHandlerData" (click)="SaveOrUpdateTemplate()">Save</button>
                } @else {
                    <button class="btn btnAS me-1" [userPermissionHandler]="createPermissionHandlerData" (click)="SaveOrUpdateTemplate()">Save</button>
                }
              
                <button class="btn btn-orange" (click)="CloseEditOrNew()">Cancel</button>
            </div>
        </div>
    </form>
</div>